import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { useTranslation } from "react-i18next";
import { LogOut } from "lucide-react";
import LanguageToggleSafe from "./LanguageToggleSafe";

export default function BrandNav() {
  const { user, logout } = useAuth();
  const { t } = useTranslation();
  const nav = useNavigate();

  const handleLogout = async () => {
    await logout();
    nav("/");
  };

  return (
    <header className="ftg-nav" data-testid="brand-nav">
      <Link to="/" className="ftg-nav__brand" data-testid="brand-link">
        <span className="ftg-nav__mark">◇</span>
        <span className="ftg-nav__name">{t("nav.brand")}</span>
      </Link>
      <nav className="ftg-nav__right">
        <LanguageToggleSafe />
        {user && user !== false ? (
          <>
            <Link to="/dashboard" className="ftg-nav__link" data-testid="nav-dashboard">
              {t("nav.dashboard")}
            </Link>
            <span className="ftg-nav__hello" data-testid="nav-hello">
              {t("nav.hello", { name: user.parent_name?.split(" ")[0] || "there" })}
            </span>
            <button
              onClick={handleLogout}
              className="ftg-btn ftg-btn--ghost"
              data-testid="nav-logout-btn"
            >
              <LogOut size={16} /> {t("nav.signOut")}
            </button>
          </>
        ) : (
          <>
            <Link to="/login" className="ftg-nav__link" data-testid="nav-login">
              {t("nav.signIn")}
            </Link>
            <Link to="/signup" className="ftg-btn ftg-btn--primary" data-testid="nav-signup">
              {t("nav.startFree")}
            </Link>
          </>
        )}
      </nav>
    </header>
  );
}
